// Author Lin
// Date 2021-11-26 11:19:21

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingCirculatingWaterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingCirculatingWater(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
